<template>
  <div>
    <v-btn v-if="canEdit"
          color="primary"
          class="mb-4"
          @click="dialog = true"
        >
        {{ $t('Create support request') }}
      </v-btn>

    <div class="mb-4">
      <task-basic-info :task="task" />
    </div>

    <div class="mb-4">
      <suport-request-list :tickets="task.tickets"/>
    </div>

    <div class="text-center my-5">
      <v-btn color="secondary" :to="{ name: 'my-workings.detail', params: {id: this.id} }" class="mr-3">{{ $t('Back to detail') }}</v-btn>
    </div>

     <v-dialog
      v-model="dialog"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('Create a ticket') }}
        </v-card-title>
        <v-card-text>
          <alert/>
          <v-form
            ref="formTicker"
            v-model="valid"
            lazy-validation
          >
            <div class="mb-3">
              <v-textarea
                  v-model="form.message"
                  :rules="rules.message"
                  :label="$t('What do you need?')"
                  hide-details="auto"
                  required
                  outlined
                  rows="3"
                  dense
                />
            </div>
            <div class="">
              <v-file-input
                  v-model="form.files_upload"
                  accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif"
                  counter
                  multiple
                  show-size
                  :label="$t('Select your files')"
                  prepend-icon=""
                  append-icon="mdi-paperclip"
                  outlined
                  hide-details="auto"
                  dense
                  :rules="rules.document"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip v-if="index < 2" label small>
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            @click="closeForm"
          >
            {{ $t('Close') }}
          </v-btn>
          <v-btn
            color="primary"
            @click="submit"
          >
            {{ $t('Submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { call, get } from 'vuex-pathify'
import validation from '@utils/validation'
import jsonToFormData from 'json-form-data'
import TaskBasicInfo from '@/components/TaskBasicInfo'
import SuportRequestList from './components/SuportRequestList'
import Alert from '@components/Alert'

export default {
  components: {
    TaskBasicInfo,
    SuportRequestList,
    Alert
  },

  data() {
    return {
      dialog: false,
      valid: true,
      form: {
        message: '',
        files_upload: []
      },
      rules: {
        message: [
          (v) => validation.required(v)
        ],
        document: [
          (v) => validation.accept(v),
          (v) => validation.arrayMax(v, 5),
          (v) => validation.filesize(v, 10 * 1024 * 1024),
          (v) => validation.required(v)
          // (v) => Validation.minlength(v, 10)
        ]
      }
    }
  },

  computed: {
    task: get('task/task'),
    userId: get('user/id'),
    id() {
      return this.$route.params.id
    },
    canEdit() {
      if (this.userId !== parseInt(this.task.user_id)) {
        return false
      }
      return ['pending', 'in_progress'].includes(this.task.status)
    }
  },

  created() {
    this.getTask(this.id)
  },

  methods: {
    getTask: call('task/getTask'),
    createTicket: call('ticket/create'),
    hideAlert: call('alert/hide'),
    loading: call('app/setLoading'),

    closeForm(e) {
      e.preventDefault()
      this.$refs.formTicker.reset()
      this.hideAlert()
      this.dialog = false
    },

    async submit(e) {
      e.preventDefault()
      const valid = this.$refs.formTicker.validate()
      if (!valid) {
        alert(this.$t('Please check data before submit!'))
        return false
      } else {
        this.hideAlert()
        this.loading(true)
        const data = {
          task_id: this.id,
          message: this.form.message,
          files_upload: this.form.files_upload
        }
        const status = await this.createTicket(jsonToFormData(data))
        this.loading(false)
        if (status) {
          this.$refs.formTicker.reset()
          this.dialog = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/_ticket.scss';
</style>
